/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileXbd32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            fill="#00838D"
        />
        <path
            d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            fill={vars.white}
            fillOpacity={0.5}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.583 16v5h2.122c.498 0 .913-.137 1.205-.395.294-.259.452-.63.452-1.076v-.007c0-.565-.34-1.026-.84-1.186.372-.18.625-.588.625-1.034v-.007c0-.394-.14-.722-.404-.95-.263-.227-.638-.345-1.09-.345h-2.07zm4.594 0v5h1.872c.697 0 1.255-.228 1.637-.667.38-.438.575-1.071.575-1.861v-.007c0-.767-.197-1.386-.58-1.813-.383-.429-.94-.652-1.632-.652h-1.872zm-2.765.948c.208 0 .358.054.455.14.095.084.15.21.15.38v.007c0 .171-.058.295-.163.38-.108.086-.279.14-.52.14h-.605v-1.047h.683zm.031 1.911c.265 0 .453.058.573.154.117.092.182.232.182.43v.006c0 .205-.064.348-.178.443-.116.098-.297.157-.555.157h-.737v-1.19h.715zm3.879 1.11V17.03h.578c.383 0 .677.132.878.37.203.24.32.602.32 1.08v.007c0 .498-.114.868-.315 1.11-.198.24-.492.37-.883.37h-.578zM9 20.996h1.35l1.033-1.62 1.035 1.62h1.415l-1.656-2.503L13.858 16H12.46l-.996 1.665L10.461 16H9.005l1.62 2.475L9 20.995z"
            fill={vars.white}
        />
    </AccessibleSVG>
);

export default FileXbd32;
